import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'

// http://playable.dev.com:8067/?doc=demand/api%2fdemand%2finteractive.go

function cookParams(params: any) {
  let newParams = { ...params }

  _.each(newParams, (value, key) => {
    if (key === 'time' && !_.isEmpty(value)) {
      newParams = _.omit(params, ['time'])
      newParams.begin_time = value[0]
      newParams.end_time = value[1]
      return
    }

    if (_.isArray(value)) {
      newParams[key] = value.join()
    }
  })

  return newParams
}

export function fetchInteractiveConfigure(params: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/configure`,
    method: 'get',
    params: params,
  })
}

export function submitInteractivePlan(data: {
  id: number
  plan_attachment?: string
  creative_spec?: string
}) {
  return request({
    url: `${v2Host}/demand/interactive/plan?id=${data.id}`,
    method: 'post',
    data: _.omit(data, ['id']),
    withoutError: 1,
  })
}

export function submitInteractiveConfigure(data: {
  id: number
  tag_ids: string
  design_attachment: string
  no_dev: number
  creative_id: number
  material_tag_ids: string
  creative_spec: string
  channels: {
    actions: {
      [key: string]: string
    }
    add_loading: number
    add_logo: number
    category_id: number
    channel_id: number
    click_types: number[]
    close_time: number
    creation_type: number
    languages: string[]
    logo_position: number
    orientation: number
    meta_cl: string
    meta_pl: string
  }[]
}) {
  return request({
    url: `${v2Host}/demand/interactive/design?id=${data.id}`,
    method: 'post',
    data: _.omit(data, ['id']),
    withoutError: 1,
  })
}

export function assignTaskToDeveloper(data: {
  id: number | string
  developer_id: number
}) {
  return request({
    url: `${v2Host}/demand/interactive/assign?id=${data.id}`,
    method: 'post',
    data: _.omit(data, ['id']),
    withoutError: 1,
  })
}

export function rejectTaskToDesigner(data: {
  id: number | string
  reason: string
}) {
  return request({
    url: `${v2Host}/demand/interactive/reject?id=${data.id}`,
    method: 'post',
    data: _.omit(data, ['id']),
  })
}

export function startDevTask(data: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/start?id=${data.id}`,
    method: 'post',
  })
}

export function fetchDeliverInfo(data: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/deliver?id=${data.id}`,
    method: 'get',
  })
}

export function fetchTmplDeliverInfo(data: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/template-test?id=${data.id}`,
    method: 'get',
  })
}

export function submitDeliverInfo(data: {
  demand_id: number
  task_ids: string
  basic_id: number
  basic_file: string
  render_type: number
  is_compress: number
  tag_ids: string
  stage: string
  tester_id: number
  priority: number
  source_type: number
  source_id: number
}) {
  return request({
    url: `${v2Host}/demand/interactive/deliver`,
    method: 'post',
    data: cookParams(data),
    withoutError: 1,
  })
}

export function fetchActionConfig(data: { mids: string }) {
  return request({
    url: `${v2Host}/demand/interactive/action-config`,
    method: 'post',
    data: cookParams(data),
  })
}

// http://playable.dev.com:8067/?doc=demand/api%2fdemand%2finteractive_task.go
export function updateInteractiveTask(data: {
  ids: string
  zip_file: string
  is_compress: number
  comment: string
}) {
  return request({
    url: `${v2Host}/demand/interactive/task/update`,
    method: 'post',
    withoutError: 1,
    data,
  })
}

export function toTestInteractiveTask(data: {
  ids: string
  tester_uid: number
}) {
  return request({
    url: `${v2Host}/demand/interactive/task/totest`,
    method: 'post',
    withoutError: 1,
    data,
  })
}

export function deleteInteractiveTask(data: { ids: string }) {
  return request({
    url: `${v2Host}/demand/interactive/task/delete`,
    method: 'post',
    data,
  })
}

/**
 * http://playable.dev.com:8067/?doc=demand/interactive.go#-demand-interactive-revocation-configure
 * 撤回配置策划案
 */
export function revocationConfigure(data: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/revocation-configure`,
    method: 'post',
    data: data,
  })
}

/**
 * http://playable.dev.com:8067/?doc=demand/interactive.go#-demand-interactive-revocation-plan
 * 撤回配置策划案
 */
export function revocationPlan(data: { id: number }) {
  return request({
    url: `${v2Host}/demand/interactive/revocation-plan`,
    method: 'post',
    data: data,
  })
}
